// Note: might need to have a different

import { V4UUID } from '@/firebase/database';
import { v4 } from 'uuid';

/**
 * Class representing a ROS Message <br></br>
 * @param {*} name - name of message
 * @param {*} fields - list of MessageField objects
 */
export const PrimativeTypes = Object.freeze({
  bool: false,
  byte: 0, // Not sure default value
  char: '', // Not sure default value
  float32: 0,
  float64: 0,
  int8: 0,
  uint8: 0,
  int16: 0,
  uint16: 0,
  int32: 0,
  uint32: 0,
  int64: 0,
  uint64: 0,
  string: ''
});

export class Message {
  id: V4UUID;
  name: string;
  fullMessageString: string; // eg turtlesim/msg/Color, contains package and folder, for terminal commands
  fields: Array<MessageField>;
  stdMsg: boolean;
  customText: string;
  constructor(
    name: string = '',
    fullMessageString: string | undefined = undefined,
    fields: Array<MessageField> = [],
    stdMsg: boolean = false,
    id: V4UUID = v4(),
    customText: string = ''
  ) {
    this.id = id;
    this.name = name;
    if (fullMessageString) this.fullMessageString = fullMessageString;
    else this.fullMessageString = name;
    this.fields = fields;
    this.stdMsg = stdMsg;
    this.customText = customText;
  }
  static fromJSON(jsonMsg: any) {
    let fieldArray: Array<MessageField> = [];
    jsonMsg.fields &&
      jsonMsg.fields.forEach((field: MessageField) => {
        fieldArray.push(MessageField.fromJSON(field));
      });
    return new Message(
      jsonMsg.name,
      jsonMsg.fullMessageString,
      fieldArray,
      jsonMsg.stdMsg,
      jsonMsg.id,
      jsonMsg.customText
    );
  }
}

export class MessageField {
  msg: V4UUID; // the id of the message type of the field
  name: string;
  defaultValue?: string; // Default values only for primative types, https://design.ros2.org/articles/interface_definition.html, ros 2 does not support default values of complex types.
  constantValue?: string;
  isArray: boolean; // Bool if array type
  typeBounds?: number; // Positive num, string size bound..., always equal to <= x
  arrayBounds?: number; // array bounds, fixed array length if arrayBoundsIsLength is true
  arrayBoundsIsLength?: boolean;
  id: string;
  constructor(
    msg: V4UUID,
    name: string,
    defaultValue: string | undefined = undefined,
    constantValue: string | undefined = undefined,
    isArray = false,
    typeBounds: number | undefined = undefined,
    arrayBounds: number | undefined = undefined,
    arrayBoundsIsLength: boolean | undefined = undefined,
    id: string = v4()
  ) {
    this.msg = msg;
    this.name = name;
    this.defaultValue = defaultValue;
    this.constantValue = constantValue;
    this.isArray = isArray;
    this.typeBounds = typeBounds;
    this.arrayBounds = arrayBounds;
    this.arrayBoundsIsLength = arrayBoundsIsLength;
    this.id = id;
  }
  static fromJSON(jsonField: any) {
    return new MessageField(
      jsonField.msg,
      jsonField.name,
      jsonField.defaultValue,
      jsonField.constantValue,
      jsonField.isArray,
      jsonField.typeBounds,
      jsonField.arrayBounds,
      jsonField.arrayBoundsIsLength,
      jsonField.id
    );
  }
}
